import gql from '@/services/gql';

interface UseResponse<Fields> {
  resource: Array<{
    products_aggregate: {
      nodes: Array<{
        product: Fields[];
      }>;
      aggregate: {
        count: number;
      };
    };
  }>;
}

export default <Fields>(
  id: string,
  resource: string,
  returnFields: string,
) => (
  gql<UseResponse<Fields>>(`
    query ProductUseQuery(
      $id: uuid!
    ) {
      resource: ${resource}(
        limit: 1
        where: {
          id: {
            _eq: $id
          }
        }
      ) {
        products_aggregate(
          limit: 1000
          order_by: {
            product: {
              name: asc
            }
          }
        ) {
          nodes {
            ${returnFields}
          }
          aggregate {
            count(columns: id)
          }
        }
      }
    }
  `)({ id })
  .then(response => {
    const {
      nodes,
      aggregate,
    } = response.resource[0].products_aggregate;
    return {
      count: aggregate.count,
      result: nodes,
    };
  })
);
